import {
  getEnterprise,
  putEnterprise,
  getEnterpriseJobList,
  getEnterpriseJobById,
  postEnterpriseJobList,
  patchEnterpriseJobList,
  getCampusRecruitments,
  getEnterpriseEnrolledCampusRecruitmentById,
  bookedCareerExpoBoothRename,
  getEnterpriseBoothAuthorizationRecordById,
  getEnterpriseBoothAuthorizationGiveById,
  getEnterpriseBoothAuthorizationTakeById,
  postCampusRecruitmentEnrollment,
  patchCampusRecruitmentEnrollment,
  deleteEnterpriseJobList,
  patchCareerExpoBooths,
  postBookingACareerExpoBooth,
  deleteBookedCareerExpoBooth,
  getCareerExpoBoothsStatus,
  sendEnterpriseInternForm,
  getEnterpriseInternForm,
  getPassEnterpriseInternForm,
  updateEnterpriseInternForm,
  getInternSearchOptions,
  getInternRecordList,
  sendInternForm,
  getInternForm,
  getEnterpriseReminder,
} from '~api/enterprises'

export const state = () => ({
  currentEnterprise: {},
  enterpriseJobs: [],
  pages: {},
  currentEnterpriseJob: {},
  enterpriseRecruitments: [],
  currentCampusRecruitment: {},
  // currentEnterpriseSpecialIssue: {},
  currentExpo: {},
  currentOrientations: {},
  currentAdvertisements: {},
  currentEnterpriseCheckout: {},
  currentAuthorizationRecord: [],
  currentAuthorizationCode: {},
  currentCareerExpoBoothsStatus: 0,
  currentInternBasicInfo: null,
  currentInternStatus: '',
  currentInternSearchOptions: [],
  currentInternRecordList: [],
  passInternBasicInfo : null,
  currentInternForm: {},
  currentEnterpriseReminder: [],
})

export const getters = {
  currentEnterpriseGetter: state => state.currentEnterprise,
  enterpriseJobsGetter: state => state.enterpriseJobs,
  pagesGetter: state => state.pages,
  currentEnterpriseJobGetter: state => state.currentEnterpriseJob,
  enterpriseRecruitmentsGetter: state => state.enterpriseRecruitments,
  currentCampusRecruitmentGetter: state => state.currentCampusRecruitment,
  // currentEnterpriseSpecialIssueGetter: state => state.currentEnterpriseSpecialIssue,
  currentExpoGetter: state => state.currentExpo,
  currentOrientationsGetter: state => state.currentOrientations,
  currentAdvertisementsGetter: state => state.currentAdvertisements,
  currentEnterpriseCheckoutGetter: state => state.currentEnterpriseCheckout,
  isEnrolledCurrentCampusRecruitmentGetter: state => (recruitmentId) => state.enterpriseRecruitments.findIndex(recruitment => recruitment.recruitment_id === recruitmentId) > -1,
  currentAuthorizationRecordGetter: state => state.currentAuthorizationRecord,
  currentAuthorizationCodeGetter: state => state.currentAuthorizationCode,
  currentCareerExpoBoothsStatusGetter: state => state.currentCareerExpoBoothsStatus,
  currentInternBasicInfoGetter: state => state.currentInternBasicInfo,
  currentInternStatusGetter: state => state.currentInternStatus,
  currentInternSearchOptionsGetter: state => state.currentInternSearchOptions,
  currentInternRecordListGetter: state => state.currentInternRecordList,
  pastInternBasicInfoGetter: state => state.passInternBasicInfo,
  currentInternFormGetter: state => state.currentInternForm,
  currentEnterpriseReminderGetter: state => state.currentEnterpriseReminder,
}

export const actions = {
  async getEnterpriseByToken ({ commit, dispatch }) {
    try {
      const data = await getEnterprise()
      commit('setCurrentEnterprise', data)
      // console.log(data, 'getEnterpriseByToken')
      return data
    } catch (err) {
      console.debug(err);
      console.log('hi');
      dispatch('auth/userLogout', 'enterprise', { root: true })
    }
  },
  async updateEnterpriseProfile ({ commit }, profile) {
    try {
      const data = await putEnterprise(profile)
      commit('setCurrentEnterprise', data)
      return data
    } catch (err) {
      return false
    }
  },
  async getEnterpriseJobList ({ commit }, params) {
    const response = await getEnterpriseJobList(params)
    const { jobs, pages } = response
    commit('setEnterpriseJobs', jobs)
    commit('setPage', pages)
    return response
  },
  async getCurrentEnterpriseJobById ({ commit }, id) {
    const job = await getEnterpriseJobById(id)
    commit('setCurrentEnterpriseJob', job)
    return job
  },
  async createJobOpening ({}, job) {
    const response = await postEnterpriseJobList(job)
    return response
  },
  async updateJobOpening ({}, data) {
    const response = await patchEnterpriseJobList(data)
    return response
  },
  async removeJobOpenings ({}, ids) {
    const response = await deleteEnterpriseJobList(ids)
    return response
  },
  async getAllCampusRecruitments ({ commit }, params) {
    const response = await getCampusRecruitments(params)
    const { recruitments, pages } = response

    commit('setEnterpriseRecruitments', recruitments)
    commit('setPage', pages)
    return response
  },
  async getEnrolledCampusRecruitmentById ({ commit, dispatch }, id) {
    const response = await getEnterpriseEnrolledCampusRecruitmentById(id)
    const {
      basicInfo,
      // specialIssue,
      enrolledExpo,
      enrolledOrientations,
      enrolledAdvertisements,
      enlistExpositionBoothTime
    } = response
    commit('setCurrentCampusRecruitment', basicInfo)
    // commit('setCurrentEnterpriseSpecialIssue', specialIssue)
    commit('setCurrentExpo', enrolledExpo)
    commit('setCurrentOrientations', enrolledOrientations)
    commit('setCurrentAdvertisements', enrolledAdvertisements)
    dispatch('updateOrder', {
      recruitmentOrientations: enrolledOrientations,
      careerExpo: enrolledExpo,
      printAdvertising: enrolledAdvertisements,
      enlistBoothTime: enlistExpositionBoothTime
    })
    return response
  },
  async bookedCareerExpoBoothRename ({ commit }, params) {
    const response = await bookedCareerExpoBoothRename(params)
    
    return response
  },
  async getEnterpriseBoothAuthorizationRecordById ({ commit }, id) {
    const response = await getEnterpriseBoothAuthorizationRecordById(id)
    const {
      authorizationRecord,
    } = response
    
    commit('setCurrentAuthorizationRecord', authorizationRecord)
    
    return response
  },
  async getEnterpriseBoothAuthorizationGiveById ({ commit }, params) {
    const response = await getEnterpriseBoothAuthorizationGiveById(params)
    
    const {
        authorizationCode
    } = response
    
    commit('setCurrentAuthorizationCode', authorizationCode)
    
    return response
  },
  async getEnterpriseBoothAuthorizationTakeById ({ commit }, params) {
    const response = await getEnterpriseBoothAuthorizationTakeById(params)
    
    return response
  },
  async submitCampusRecruitmentEnrollment ({}, enrollment) {
    const response = await postCampusRecruitmentEnrollment(enrollment)
    return response
  },
  updateOrder ({ commit }, order) {
    commit('setCurrentEnterpriseCheckout', order)
  },
  removeOrder ({ commit }, order) {
    commit('removeFromCurrentEnterpriseCheckout', order)
  },
  clearOrders ({ commit }) {
    commit('resetCurrentEnterpriseCheckout')
  },
  async modifyOrderById ({}, order) {
    const response = await patchCampusRecruitmentEnrollment(order)
    return response
  },
  logout ({ commit }) {
    commit('resetCurrentEnterprise')
  },
  async updateExpoBooths ({}, data) {
    const response = await patchCareerExpoBooths(data)
    return response
  },
  async bookingACareerExpoBooth ({}, data) {
    try {
      const response = await postBookingACareerExpoBooth(data)
      return response
    } catch (err) {
      return err
    }
  },
  async deletingTheBookedExpoBooth ({}, data) {
    try {
      const response = await deleteBookedCareerExpoBooth(data)
      return response
    } catch (err) {
      return err
    }
  },
  async getCareerExpoBoothsStatus ({ commit }, id) {
    const {
      careerExpoBoothsStatus
    } = await getCareerExpoBoothsStatus(id)

    commit('setCurrentCareerExpoBoothsStatus', careerExpoBoothsStatus)
    
    return careerExpoBoothsStatus
  },
  async sendEnterpriseInternForm ({ commit }, internBasicInfo) {
    const response = await sendEnterpriseInternForm(internBasicInfo)
    return response
  },
  async getEnterpriseInternForm ({ commit }) {
    const {
      internBasicInfo,
      internStatus,
    } = await getEnterpriseInternForm()

    commit('setCurrentInternBasicInfo', internBasicInfo)
    commit('setCurrentInternStatus', internStatus);

    return internBasicInfo
  },
  async getPassEnterpriseInternForm ({ commit }) {
    const internBasicInfo = await getPassEnterpriseInternForm()
    commit('setPassInternBasicInfo', internBasicInfo);

    return internBasicInfo
  },
  async updateEnterpriseInternForm ({ commit }, internBasicInfo) {
    const response = await updateEnterpriseInternForm(internBasicInfo)
    return response
  },
  async getInternSearchOptions ({ commit }) {
    const response = await getInternSearchOptions();
    const {
      internSearchOptions
    } = response
    commit('setInternSearchOptions', internSearchOptions)
    return response
  },
  async getInternRecordList ({ commit }, params) {
    const response = await getInternRecordList(params);
    const {
      internRecordList
    } = response
    commit('setInternRecordList', internRecordList)
    return response
  },
  async sendInternForm ({ commit }, params) {
    const response = await sendInternForm(params);
    return response
  },
  async getInternForm ({ commit }, params) {
    const response = await getInternForm(params);
    const {
      formData
    } = response
    commit('setInternForm', formData)
    return response
  },
  async getEnterpriseReminder ({ commit }) {
    const response = await getEnterpriseReminder();
    commit('setEnterpriseReminder', response);
    return response
  },
}

export const mutations = {
  setCurrentEnterprise (state, payload) {
    state.currentEnterprise = Object.assign({}, payload)
  },
  resetCurrentEnterprise (state, payload) {
    state.currentEnterprise = Object.assign({})
  },
  setEnterpriseJobs (state, payload) {
    state.enterpriseJobs = payload
  },
  setPage (state, payload) {
    state.pages = payload
  },
  setCurrentEnterpriseJob (state, payload) {
    state.currentEnterpriseJob = Object.assign({}, payload)
  },
  setEnterpriseRecruitments (state, payload) {
    state.enterpriseRecruitments = payload
  },
  setCurrentCampusRecruitment (state, payload) {
    state.currentCampusRecruitment = Object.assign({}, payload)
  },
  // setCurrentEnterpriseSpecialIssue (state, payload) {
  //   state.currentEnterpriseSpecialIssue = Object.assign({}, payload)
  // },
  setCurrentExpo (state, payload) {
    state.currentExpo = Object.assign({}, payload)
  },
  setCurrentOrientations (state, payload) {
    state.currentOrientations = Object.assign({}, payload)
  },
  setCurrentAdvertisements (state, payload) {
    state.currentAdvertisements = Object.assign({}, payload)
  },
  setCurrentAuthorizationRecord (state, payload) {
    state.currentAuthorizationRecord = payload;
  },
  setCurrentAuthorizationCode (state, payload) {
    state.currentAuthorizationCode = payload;
  },
  setCurrentCareerExpoBoothsStatus (state, payload) {
    state.currentCareerExpoBoothsStatus = payload;
  },
  setCurrentInternBasicInfo (state, payload) {
    state.currentInternBasicInfo = payload;
  },
  setPassInternBasicInfo (state, payload) {
    state.passInternBasicInfo = payload;
  },
  setCurrentInternStatus (state, payload) {
    state.currentInternStatus = payload;
  },
  setInternSearchOptions (state, payload) {
    state.currentInternSearchOptions = Object.assign({}, payload);
  },
  setInternRecordList (state, payload) {
    state.currentInternRecordList = payload;
  },
  setCurrentEnterpriseCheckout (state, payload) {
    Object.keys(payload).forEach(key => {
      if (Object.keys(payload[key]).length) {
        state.currentEnterpriseCheckout = Object.assign(
          {},
          state.currentEnterpriseCheckout,
          {
            [key]: payload[key]
          }
        )
      }
    })
  },
  // setCurrentOrders (state, payload) {
  //   const currentOrders = {}
  //   if (
  //     Object.keys(payload.enrolledOrientations).length &&
  //     state.currentCampusRecruitment.recruitment_orientation_enabled
  //   ) {
  //     currentOrders.recruitmentOrientations = payload.enrolledOrientations
  //   }
  //   if (
  //     Object.keys(payload.enrolledExpo).length &&
  //     state.currentCampusRecruitment.career_expo_enabled
  //   ) {
  //     currentOrders.careerExpo = payload.enrolledExpo
  //   }

  //   if (
  //     Object.keys(payload.enrolledAdvertisements).length &&
  //     state.currentCampusRecruitment.print_advertising_enabled
  //   ) {
  //     currentOrders.printAdvertising = payload.enrolledAdvertisements
  //   }

  //   state.currentEnterpriseCheckout = Object.assign({}, currentOrders)
  // },
  removeFromCurrentEnterpriseCheckout (state, payload) {
    const clone = Object.assign({}, state.currentEnterpriseCheckout)
    delete clone[payload]
    state.currentEnterpriseCheckout = clone
  },
  resetCurrentEnterpriseCheckout (state, payload) {
    state.currentEnterpriseCheckout = Object.assign({})
  },
  setInternForm (state, payload) {
    state.currentInternForm = Object.assign({}, payload)
  },
  setEnterpriseReminder (state, payload) {
    state.currentEnterpriseReminder = payload;
  },
}
